import "@momentum-ui/framework/dist/styles/global.scss";
import React from "react";
import ReactDOM from "react-dom";
import { App } from "@momentum-ui/framework";
import catalog from "./catalog/catalog.g";
// So the transpiler knows about the "L" method.
import "@momentum-ui/framework/dist/icwcore/extensionmethods/ExtensionMethodsString";
ReactDOM.render(<App catalog={catalog}/>, document.getElementById("root"));